import React, { useState, useEffect, useRef } from "react";
import styles from "./PlanATripMain.module.css";

import Select, { components } from "react-select";
import { AiFillCaretDown } from "react-icons/ai";
import Radio from "@material-ui/core/Radio";
import DatePicker from "react-datepicker";
import { Link, useHistory } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { countryApi } from "../../../config/countryApi";

import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsCheckAll } from "react-icons/bs";
import { BiError } from "react-icons/bi";
import { MdExpandMore } from "react-icons/md";

import { connect } from "react-redux";
import changeDetails from "../../../store/Actions/DetailsAction";

import { countryVisaApi } from "../../../config/countryVisaApi";
import { countriesApi } from "../../../config/countriesApi";

function PlanATripMain(props) {
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(true);

  const options3 = [
    { value: "7", label: "7 Days" },
    { value: "14", label: "14 Days" },
    { value: "30", label: "30 Days" },
    { value: "45", label: "45 Days" },
  ];

  const [show, setShow] = useState(false);
  const showBox = useRef();

  useEffect(() => {
    document.addEventListener("mousedown", checkClick);
    return () => {
      document.removeEventListener("mousedown", checkClick);
    };
  }, []);

  const checkClick = (e) => {
    if (e.offsetX > e.target.clientWidth || e.offsetY > e.target.clientHeight) {
      return;
    } else if (showBox.current.contains(e.target)) {
      return;
    }
    setShow(false);
  };

  const [service, setService] = useState("");
  const [adults, setAdults] = useState(0);
  const [childrens, setChildrens] = useState(0);
  const [infants, setInfants] = useState(0);
  const [visaTypes, setVisaTypes] = useState("");
  const [normalFees, setNormalFees] = useState(0);
  const [expressFees, setExpressFees] = useState(0);
  const [embassyFees, setEmbassyFees] = useState(0);
  const [total, setTotal] = useState(0);

  const history = useHistory();

  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedCountryId, setSelectedCountryId] = useState("");
  const [selectedVisaType, setSelectedVisaType] = useState("");
  const [selectedVisaId, setSelectedVisaId] = useState(null);
  const [selectedStayDuration, setSelectedStayDuration] = useState(0);
  const [persons, setPersons] = useState(0);
  const [personsDetails, setPersonsDetails] = useState({
    adults,
    childrens,
    infants,
  });
  const [travelDate, setTravelDate] = useState("");
  const [returnDate, setReturnDate] = useState("");

  const [countryValue, setCountryValue] = useState("");
  const [selectedType, setSelectedType] = useState("");

  const [fees, setFees] = useState(0);

  const [countryData, setCountryData] = useState([]);
  const [currentCountry, setCurrentCountry] = useState(null);
  const [options1, setOptions1] = useState([
    { id: "0", label: "Loading...", isDisabled: true },
  ]);
  const [options2, setOptions2] = useState([
    { id: "0", label: "Select Destination First...", isDisabled: true },
  ]);

  const opt1 = useRef();
  const opt2 = useRef();
  const opt3 = useRef();
  const opt4 = useRef();
  const opt5 = useRef();

  const date = new Date();

  const TravelCustomInput = ({ value, onClick }) => (
    <button className={styles.btnDate} onClick={onClick}>
      {value !== "" ? (
        <span
          style={{
            display: "flex",
            justifyContent: "space-between",
            color: "#000000",
          }}
        >
          {value} <AiFillCaretDown size={20} color="#915713" />
        </span>
      ) : (
        <span
          style={{
            color: "#000000",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          Travel Date <AiFillCaretDown size={20} color="#915713" />
        </span>
      )}
    </button>
  );

  const ReturnCustomInput = ({ value, onClick }) => (
    <button className={styles.btnDate} onClick={onClick}>
      {value !== "" ? (
        <span
          style={{
            display: "flex",
            justifyContent: "space-between",
            color: "#000000",
          }}
        >
          {value} <AiFillCaretDown size={20} color="#915713" />
        </span>
      ) : (
        <span
          style={{
            color: "#000000",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          Return Date <AiFillCaretDown size={20} color="#915713" />
        </span>
      )}
    </button>
  );

  // const handleService = (e, fee) => {
  //   if (fee !== 0) {
  //     setService(e);
  //     setFees(fee);
  //     setAdults(0)
  //     setChildrens(0)
  //     setInfants(0)
  //     setTotal(0)
  //   }
  //   else {
  //     toast.error(
  //       <span style={{ display: "flex", alignItems: "center" }}>
  //         <BiError size="30" style={{ marginRight: "10px" }} />
  //         Please Select Visa Type First!
  //       </span>,
  //       {
  //         position: "bottom-left",
  //         autoClose: 5000,
  //         hideProgressBar: true,
  //         closeOnClick: true,
  //         pauseOnHover: false,
  //         draggable: true,
  //         progress: undefined,
  //       }
  //     );
  //   };
  // };

  const handleAdultsInc = () => {
    setAdults(adults + 1);
    setPersons(persons + 1);
    setPersonsDetails({
      adults: adults + 1,
      childrens: childrens,
      infants: infants,
    });
    // setTotal(total + (fees + embassyFees));
  };
  const handleChildrensInc = () => {
    setChildrens(childrens + 1);
    setPersons(persons + 1);
    setPersonsDetails({
      adults: adults,
      childrens: childrens + 1,
      infants: infants,
    });
    // setTotal(total + (fees + embassyFees));
  };
  const handleInfantsInc = () => {
    setInfants(infants + 1);
    setPersons(persons + 1);
    setPersonsDetails({
      adults: adults,
      childrens: childrens,
      infants: infants + 1,
    });
    // setTotal(total + (fees + embassyFees));
  };
  const handleAdultsDec = () => {
    if (adults > 0) {
      setAdults(adults - 1);
      setPersons(persons - 1);
      setPersonsDetails({
        adults: adults - 1,
        childrens: childrens,
        infants: infants,
      });
      // setTotal(total - (fees + embassyFees));
    }
  };
  const handleChildrensDec = () => {
    if (childrens > 0) {
      setChildrens(childrens - 1);
      setPersons(persons - 1);
      setPersonsDetails({
        adults: adults,
        childrens: childrens - 1,
        infants: infants,
      });
      // setTotal(total - (fees + embassyFees));
    }
  };
  const handleInfantsDec = () => {
    if (infants > 0) {
      setInfants(infants - 1);
      setPersons(persons - 1);
      setPersonsDetails({
        adults: adults,
        childrens: childrens,
        infants: infants - 1,
      });
      // setTotal(total - (fees + embassyFees));
    }
  };

  const handleDestination = async (e) => {

    setOptions2([{ label: "Loading...", isDisabled: true }]);
    const country = await countryApi(e.value);

    if (country.data) {
      setSelectedCountry(e.value);
      setOptions2([]);
      opt2.current.select.clearValue();
      setTravelDate("");
      setReturnDate("");
      const cont = await country.data.data;
      setSelectedCountryId(cont._id);
      if (cont.visa_packages.length !== 0) {
        cont.visa_packages.map((value) => {
          setOptions2((options2) => [
            ...options2,
            { value: value.name, label: value.name, id: value._id },
          ]);
        });
      } else {
        setOptions2([]);
        opt2.current.select.clearValue();
        setTravelDate("");
        setReturnDate("");
      }
    } else if (country.error) {
      setOptions2([]);
      opt2.current.select.clearValue();
      setTravelDate("");
      setReturnDate("");
    }
  };

  const handleVisaType = async (e) => {
    if (e !== null) {
      const country = await countryApi(selectedCountry);
      setSelectedVisaType(e.value);
      setSelectedVisaId(e.id);
      if (country.data) {
        setTravelDate("");
        setReturnDate("");
        const cont = await country.data.data;
        cont.visa_packages.map((value) => {
          if (value.name === e.value) {
            setNormalFees(value.normal_service_fee);
            setExpressFees(value.express_service_fee);
            setEmbassyFees(value.embassy_fee);
          }
        });
      } else if (country.error) {
        setNormalFees(0);
        setExpressFees(0);
        setTravelDate("");
        setReturnDate("");
      }
    }
  };

  const handleStayDuration = (e) => {
    if (e !== null) {
      setSelectedStayDuration(e.value);
    }
  };
  // const apply = () => {
  //   if (
  //     selectedStayDuration !== null &&
  //     selectedVisaType !== null &&
  //     selectedCountryId !== null &&
  //     selectedVisaId !== null &&
  //     selectedStayDuration !== 0 &&
  //     travelDate !== "" &&
  //     returnDate !== "" &&
  //     service !== "" &&
  //     persons !== 0
  //   ) {
  //     props.ChangeDetails({
  //       country: selectedCountry,
  //       country_id: selectedCountryId,
  //       visa_type: selectedVisaType,
  //       visa_id: selectedVisaId,
  //       stay_duration: selectedStayDuration,
  //       travel_date: travelDate,
  //       return_date: returnDate,
  //       service: service,
  //       persons: persons,
  //       persons_details: personsDetails,
  //       embassy_fees: embassyFees * persons,
  //       service_fees: fees * persons,
  //       total: total,
  //     });
  //     history.push(`/countries/${selectedCountry}/payment`);
  //   } else {
  //     toast.error(
  //       <span style={{ display: "flex", alignItems: "center" }}>
  //         <BiError size="30" style={{ marginRight: "10px" }} />
  //         All Fields Are Required!
  //       </span>,
  //       {
  //         position: "bottom-left",
  //         autoClose: 5000,
  //         hideProgressBar: true,
  //         closeOnClick: true,
  //         pauseOnHover: false,
  //         draggable: true,
  //         progress: undefined,
  //       }
  //     );
  //   }
  // };

  const style1 = {
    control: (base) => ({
      ...base,
      border: "0 !important",
      boxShadow: "0 !important",
      fontSize: "16px",
      fontFamily: "Montserra",
      fontWeight: 400,
      lineHeight: "20px",
      //   backgroundColor: "#DEF3FF",
      cursor: "pointer",
      height: "60px",
      borderRadius: "10px",
      "&:hover": {
        border: "0 !important",
      },
    }),
    menu: (base) => ({
      ...base,
      marginTop: 2,
      fontSize: 16,
      maxWidth: 341,
    }),
    dropdownIndicator: (defaultStyles) => ({
      ...defaultStyles,
      color: "#7FA2B6",
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      transform: state.selectProps.menuIsOpen && "rotate(180deg)",
      color: "#7FA2B6",
      "&:hover": {
        color: "#7FA2B6",
      },
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isDisabled ? "#ffffff" : isFocused ? "#E7E7E7" : null,
        color: "#20313B",
        cursor: isDisabled ? "not-allowed" : "default",
      };
    },
  };

  const style2 = {
    control: (base) => ({
      ...base,
      boxShadow: "0 !important",
      fontSize: "16px",
      fontFamily: "Montserra",
      fontWeight: 400,
      lineHeight: "20px",
      cursor: "pointer",
    }),
    menu: (base) => ({
      ...base,
      marginTop: 2,
      fontSize: 16,
      maxWidth: 341,
    }),
    dropdownIndicator: (defaultStyles) => ({
      ...defaultStyles,
      color: "#7FA2B6",
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      transform: state.selectProps.menuIsOpen && "rotate(180deg)",
      color: "#7FA2B6",
      "&:hover": {
        color: "#7FA2B6",
      },
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isDisabled ? "#ffffff" : isFocused ? "#E7E7E7" : null,
        cursor: isDisabled ? "not-allowed" : "default",
        color: "#164550",
        cursor: isDisabled ? "not-allowed" : "default",
        fontSize: "18px",
        fontFamily: "Roboto",
      };
    },
  };

  const DropdownIndicator = (
    props: ElementConfig<typeof components.DropdownIndicator>
  ) => {
    return (
      <components.DropdownIndicator {...props}>
        <AiFillCaretDown size={20} color="#915713" />
      </components.DropdownIndicator>
    );
  };
  const daysDiff = (date2) => {
    const diffTime = Math.abs(date2 - travelDate);
const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
setSelectedStayDuration(diffDays);
  }

  const search = () => {


   const allInfo = {
        country: selectedCountry,
        country_id: selectedCountryId,
        visa_type: selectedVisaType,
        visa_id: selectedVisaId,
        stay_duration: selectedStayDuration,
        travel_date: travelDate,
        return_date: returnDate,
        persons: persons,
        persons_details: personsDetails,
        normal_fees: normalFees,
        express_fees: expressFees,
        embassy_fees: embassyFees
      }

      if (
        selectedStayDuration !== null &&
        selectedVisaType !== null &&
        selectedCountryId !== null &&
        selectedVisaId !== null &&
        selectedStayDuration !== 0 &&
        travelDate !== "" &&
        returnDate !== "" &&
        persons !== 0
      ) {
          props.ChangeDetails(allInfo)
          history.push('/dashboard/plan-a-trip/processing-time')

      } else {
        toast.error(
          <span style={{ display: "flex", alignItems: "center" }}>
            <BiError size="30" style={{ marginRight: "10px" }} />
            All Fields Are Required!
          </span>,
          {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
          }
        );
      }


  };

  useEffect(() => {
    function getWithExpiry(key) {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) {
        return null;
      }

      const item = JSON.parse(itemStr);
      const now = new Date();

      if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        console.log("REMOVE");
        return null;
      }

      return item.value;
    }
    getWithExpiry("userData");

    const countries = async () => {
      const countries = await countriesApi();

      if (countries.data) {
        const cont = await countries.data.data;
        setData(countries.data.data);

        setLoader(false);
        setOptions1([]);
        setOptions1([{ label: "Popular Countries", isDisabled: true }]);
        cont.map((value) => {
          setOptions1((options1) => [
            ...options1,
            {
              id: value._id,
              value: value.display_name,
              label: (
                <span
                  dangerouslySetInnerHTML={{
                    __html: `<b>${value.code}</b> &nbsp; &nbsp; &nbsp; ${value.display_name}`,
                  }}
                />
              ),
            },
          ]);
        });
      } else if (countries.error) {
        console.log(countries.error);
        setLoader(false);
      }
    };
    countries();
  }, []);

  return (
    <div>
      <h2 className={styles.head}>Start a new application</h2>
      <h2 className={styles.head2}>Create visa application</h2>
      <div className={styles.box1}>
        <div className={styles.box1FirstCont}>
          <p className={styles.badge}>1 of 5</p>
          <p className={styles.FirstText}>Please enter travel details?</p>
        </div>
        <div className={styles.mainCont}>
          <div className={styles.InputsAllBox}>
            <div className={styles.selection1}>
              <div className={styles.select}>
                <Select
                  styles={style1}
                  className={styles.inners}
                  isSearchable={false}
                  options={options1}
                  ref={opt1}
                  value={countryValue}
                  placeholder={"Destination"}
                  onChange={(e) => {
                    setCountryValue([e]);
                    handleDestination(e);
                  }}
                  components={{
                    IndicatorSeparator: () => null,
                    DropdownIndicator,
                  }}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      neutral50: "#000000",
                    },
                  })}
                />
              </div>
              <div className={styles.select}>
                <Select
                  styles={style1}
                  ref={opt2}
                  className={styles.inners}
                  isSearchable={false}
                  options={options2}
                  placeholder={"Visa type"}
                  value={selectedType}
                  onChange={(e) => {
                    setSelectedType([e]);
                    handleVisaType(e);
                  }}
                  components={{
                    IndicatorSeparator: () => null,
                    DropdownIndicator,
                  }}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      neutral50: "#000000",
                    },
                  })}
                />
              </div>
            </div>
            <div className={styles.selection2}>
              <div className={styles.select1}>
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  selected={travelDate}
                  onChange={(date) => {
                    setTravelDate(date);
                    setReturnDate("");
                  }}
                  customInput={<TravelCustomInput />}
                  minDate={new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)}
                  // maxDate={new Date(Date.now() + (selectedStayDuration+5)* 24 * 60 * 60 * 1000)}
                  allowSameDay={false}
                  ref={opt4}
                />
              </div>

              <div className={styles.select1}>
                <DatePicker
                  selected={returnDate}
                  onChange={(date) => {setReturnDate(date); daysDiff(date)} }
                  customInput={<ReturnCustomInput />}
                  minDate={travelDate}
                  // maxDate={new Date(Date.now() + selectedStayDuration * 24 * 60 * 60 * 1000)}
                  dateFormat="dd/MM/yyyy"
                  ref={opt5}
                />
              </div>
              <div ref={showBox}>
                <div className={styles.select12} onClick={() => setShow(!show)}>
                  <h1 className={styles.headOfSelect}>{(persons === 0) ? (
                    "Travellers"
                  ):
                  (
                    ((persons === 1)?(
                      `${persons} Person`
                    )
                    :
                    (
                      `${persons} Persons`
                    ))
                    
                  )}</h1>
                  <AiFillCaretDown size={20} color="#915713" />
                </div>
                {show ? (
                  <>
                    <div className={styles.last}>
                      <div className={styles.lastBox}>
                        <div style={{ width: "90px" }}>
                          <h1 className={styles.lastHead}>
                            Adults<p className={styles.lastDess}>12+ yrs</p>{" "}
                          </h1>
                        </div>
                        <div className={styles.lastbtns}>
                          <button
                            className={styles.btn1}
                            onClick={() => {
                              handleAdultsDec();
                            }}
                          >
                            -
                          </button>
                          <p className={styles.lastpera}>{adults}</p>
                          <button
                            className={styles.btn2}
                            onClick={() => {
                              handleAdultsInc();
                            }}
                          >
                            +
                          </button>
                        </div>
                      </div>
                      <div className={styles.lastBox}>
                        <div style={{ width: "90px" }}>
                          <h1 className={styles.lastHead}>
                            Children<p className={styles.lastDess}>2-11 yrs</p>{" "}
                          </h1>
                        </div>
                        <div className={styles.lastbtns}>
                          <button
                            className={styles.btn1}
                            onClick={() => {
                              handleChildrensDec();
                            }}
                          >
                            -
                          </button>
                          <p className={styles.lastpera}>{childrens}</p>
                          <button
                            className={styles.btn2}
                            onClick={() => {
                              handleChildrensInc();
                            }}
                          >
                            +
                          </button>
                        </div>
                      </div>
                      <div className={styles.lastBox}>
                        <div style={{ width: "90px" }}>
                          <h1 className={styles.lastHead}>
                            Infants
                            <p className={styles.lastDess}>under 2 yrs</p>{" "}
                          </h1>
                        </div>
                        <div className={styles.lastbtns}>
                          <button
                            className={styles.btn1}
                            onClick={() => {
                              handleInfantsDec();
                            }}
                          >
                            -
                          </button>
                          <p className={styles.lastpera}>{infants}</p>
                          <button
                            className={styles.btn2}
                            onClick={() => {
                              handleInfantsInc();
                            }}
                          >
                            +
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                ) : null}
              </div>
            </div>
          </div>

          <button className={styles.search} onClick={() => search()}>
            Search
          </button>
        </div>
      </div>
      <div className={styles.mar}>
        <h2 className={styles.head2}>Recent Search</h2>
      </div>
      
          {loader ? (
            <div className={styles.loader}>
              <div
                className="spinner-border"
                role="status"
                style={{ position: "relative" }}
              ></div>
            </div>
          ) : (
            <div className={styles.main}>
        <div className={styles.cards}>
            {data.map((value, index) => (
              <div className={styles.card} key={index}>
                <img
                  src={value.cover_image}
                  alt="cover_image"
                  className={styles.cardImage}
                />
                <div
                  className={styles.cardBottom}
                  onClick={(e) => {
                    setCountryValue([
                      {
                        id: value._id,
                        value: value.display_name,
                        label: (
                          <span
                            dangerouslySetInnerHTML={{
                              __html: `<b>${value.code}</b> &nbsp; &nbsp; &nbsp; ${value.display_name}`,
                            }}
                          />
                        ),
                      },
                    ]);
                    handleDestination({
                      id: value._id,
                      value: value.display_name,
                      label: (
                        <span
                          dangerouslySetInnerHTML={{
                            __html: `<b>${value.code}</b> &nbsp; &nbsp; &nbsp; ${value.display_name}`,
                          }}
                        />
                      ),
                    });
                    window.scrollTo(0, 0);
                  }}
                >
                  <h1 className={styles.cardBottomName}>
                    {value.display_name}
                  </h1>
                  <div>
                    <h1 className={styles.cardBottomLearn}>
                      <MdExpandMore className={styles.left} />
                    </h1>
                  </div>
                </div>
              </div>

            ))}
            </div>
    </div>
          )
          }
          <ToastContainer
        transition={Slide}
        position="bottom-left"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        className={styles.toasst}
      />
        </div>

  );
}


const mapStateToProps = (state) => ({
  details: state.Details.details,
});

const mapDispatchToProp = (dispatch) => ({
  ChangeDetails: (details) => dispatch(changeDetails(details)),
});

export default connect(mapStateToProps, mapDispatchToProp)(PlanATripMain);